
import { Vue } from "vue-class-component";

export default class Dex extends Vue {}
